import { useContext, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PageContext from './PageContext';
import PageDropdown from './PageDropdownCopy.jsx';
import AutoCompleteInput from './AutoCompleteInputCopy.jsx';
import { HttpContext } from '../../api-services/HttpService';
import ApiRequestButton from './ApiRequestButton';
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';

const AddCompanyEntitlementsModal = () => {
    // initialize PageContext from parent
    const {
        addEntitlementsModal, 
        setAddEntitlementsModal, 
        roleList, 
        userList, 
        masterCompanyData, 
        getCompanyDetailsData,
        snackbarAlert,
    } = useContext(PageContext);

    // initialize http context 
    const { 
        POST, 
    } = useContext(HttpContext);

    // get persistant redux global state from store
    const company = useSelector((state) => state.company);
    // set state for role dropdown
    const [role, setRole] = useState('--select--');
    // set state for user autocomplete
    const [searchUser, setSearchUser] = useState('');

    // event handler for submit click
    const onSubmitClick = () => {
        return new Promise((resolve, reject) => {
            let response; 
            // check for valid input 
            if (role == '--select--' || searchUser == ''){
                snackbarAlert(true, 'Error: Invalid input.', 'error');
                reject(); 
                return 
            }
            // check to make sure primaryCCRM is in user list 
            if (!userList.includes(searchUser)){
                snackbarAlert(true, 'Choose valid user for Primay ' + process.env.REACT_APP_CCRM_DESCRIPTION + '.', 'error'); 
                reject(); 
                return; 
            }
            // make POST request
            POST('/data/companyEntitlements', {
                userroledescription: role, 
                userid: searchUser, 
                mastercompanyid: masterCompanyData['mastercompanyid'],
                active: true, 
            }).then(res => {
                console.log(res);
                response = res;
                // make modal hidden
                setAddEntitlementsModal(addEntitlementsModal => addEntitlementsModal = false);
                // default state 
                setRole(role => role = '--select--'); 
                setSearchUser(searchUser => searchUser = ''); 
                // trigger success alert
                snackbarAlert(true, 'Successfully uploaded data.', 'success');
                // refresh CompanyDetailsPage using function from parent
                return getCompanyDetailsData(company);
            }).then(res => {
                console.log(res);
                // resolve on success
                resolve(response); 
            }).catch(err => {
                console.log(err);
                // show alert on error
                snackbarAlert(true, 'Error uploading data.', 'error');
                // reject on error
                reject(err); 
            });
        }); 
    }

    return(
        <> 
            <CCOffcanvas
                title = 'Add Entitlement'
                show={addEntitlementsModal}
                onCanvasClose={()=>setAddEntitlementsModal(addEntitlementsModal => addEntitlementsModal = false)}
                bodyCssClassName="offcanvas-body bg-white p-3 pt-2"
                offCanvasClassName="offcanvas-parent-card-30"
                >
                <div className="d-flex flex-column h-100">
                    <div className="d-flex flex-column gap-3 flex-grow-1 overflow-scroll">
                        {/* dropdown to choose role for adding user */}
                        <PageDropdown tag='Role' value={role} setValue={setRole} list={roleList} width='100%' topAlignTypography={true}/>
                        {/* autocomplete that allows a search of active users */}
                        <AutoCompleteInput tag='Search User' value={searchUser} setValue={setSearchUser} list={userList} width='100%' topAlignTypography={true}/>
                    </div>
                    {/* button to submit user addition */}
                    <div
                            className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                        >
                            {/* <button className='entitlement-modal-button' onClick={(e)=>onSubmitClick(e)}>Submit</button> */}
                            <ButtonComponent tag={"Cancel"} 
                                border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'} 
                                onButtonClick={()=>setAddEntitlementsModal(addEntitlementsModal => addEntitlementsModal = false)}
                            />
                            <ApiRequestButton onButtonClick={onSubmitClick}/>
                    </div>
                </div>

            </CCOffcanvas>
        </>
    );
}

export default AddCompanyEntitlementsModal;